//#region lib/Image/lib/parseImageJSON.ts
function e(e) {
	try {
		let t = JSON.parse(e);
		if (typeof t == "object" && t && typeof t.href == "string" && t.href !== "") return t;
	} catch {}
}
//#endregion
export { e as parseImageJSON };
